import React, { forwardRef } from 'react';
import { cn } from '@/utils/cn';

export interface LabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
  htmlFor?: string;
  required?: boolean;
  requiredClassName?: string;
  className?: string;
  isError?: boolean;
}

const Label = forwardRef<HTMLLabelElement, LabelProps>(
  ({ children, htmlFor, required = false, requiredClassName, className, isError = false, ...props }, ref) => {
    return (
      <label
        ref={ref}
        htmlFor={htmlFor}
        {...props}
        className={cn(
          // Layout & size
          'text-[14px] font-[400] leading-none select-none',
          // Base colors
          'text-[#25151E]',
          // Focus & transition
          'peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
          // Error state
          isError && 'text-[#CC0202]',
          // Custom overrides
          className
        )}
      >
        {children}
        {required ? (
          <span aria-hidden="true" className={cn('ml-[2px] text-[#CC0202] font-[600]', requiredClassName)}>
            *
          </span>
        ) : null}
      </label>
    );
  }
);

Label.displayName = 'Label';

export default Label;
